skrilla.controller('adminDetailsCtrl', function ($scope, searchService, cacheService) {
    $scope.selected = false;



    $scope.saveDetails = function(){
        searchService.put('admins/' + $scope.admin.id, $scope.admin, "Admin details Successfully updated!").then(function successCallback(response) {
            $scope.promotion = response.data;
        });
    }
    searchService.get("roles").then(function(response){$scope.roles = response.data.filter((it) => it.type = "Admin");});

    /*searchService.get('admins/' + $stateParams.id).then(function(response){
        $scope.admin = response.data;
        //$scope.adminHasRoles();
    });*/
    $scope.admin = cacheService.getObject("admin")

    $scope.adminHasRoles = function(role){
        for(var i = 0; i < $scope.admin.roles.length; i ++){
            $scope.roles.forEach(function(role){
                if(role.name == $scope.admin.roles[i]) role.selected = true;
            });
        }
    }

    $scope.saveRole = function(){
        searchService.put("admins/" + $scope.admin.id + "/role/" + $scope.admin.roleName, {}, "Role successfully updated!");
    }

    $scope.updateStatus = function(){
        var status = $scope.admin.status === "LOCKED" ? "ACTIVE" : "LOCKED";
        searchService.put("admins/" + $scope.admin.id + "/status/" + status, {}, "Admin Status updated!").then(function(response){
            $scope.admin.status = status;
        });
    }

    $scope.resetPassword = function(){
        searchService.put("admins/" + $scope.admin.id + "/forceResetPassword" , {}, "Password reset now forced on next login.");
    }

    $scope.resetMFA = function(){
        searchService.put("admins/" + $scope.admin.id + "/forceResetMFA" , {}, "MFA reset now forced on next login.");
    }

});

